import { getAccessToken } from '../utils/okta-config';
import { API_ROOT } from '../constants/constants';
import { log } from "../Helper";
import { toast } from 'react-toastify';

export const fetchAvailableReports = async () => {
    let result = [];
    try {
        let url = `${process.env.REACT_APP_API_ENDPOINT}/reports/getAvailableReports`;
        const requestOptions = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
                "Access-Control-Allow-Origin": API_ROOT,
            },
        };
        const response = await fetch(url, requestOptions);
        if (response.status === 200) {
            result = await response.json();
        }
    } catch (error) {
        log('Error fetching available reports:', error);
    }
    return result;
}

export const downloadReport = async (reportId, reportName) => {
    try {
        let url = `${process.env.REACT_APP_API_ENDPOINT}/reports/getReport/id/` + reportId + `/name/` + reportName;
        const requestOptions = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
                "Access-Control-Allow-Origin": API_ROOT,
            },
        };

        const response = await fetch(url, requestOptions);
        log(response);
        
        if (response.status === 404) {
            const errorData = await response.json();
            toast.warn(errorData.message);
            return { success: false, error: errorData.message, errorCode: 404 };
        }

        if (response.status === 400) {
            const errorData = await response.json();
            toast.warn(errorData.message);
            return { success: false, error: errorData.message, errorCode: 400 };
        }

        if (!response.ok) {
            const errorData = await response.json();
            toast.error(errorData.message);
            return { success: false, error: errorData.message };
        }

        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'DMContainerReport.xlsx';
        
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[*]?=(?:UTF-8'')?["']?([^"';,\n\r\f]+)["']?/i);
            if (fileNameMatch && fileNameMatch[1]) {
                fileName = decodeURIComponent(fileNameMatch[1].trim());
            }
        } else {
            // Fallback
            const now = new Date();
            const timestamp = now.getFullYear() + '-' + 
                            String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                            String(now.getDate()).padStart(2, '0') + '-' + 
                            String(now.getHours()).padStart(2, '0') + 
                            String(now.getMinutes()).padStart(2, '0');
            fileName = `DMContainerReport-${timestamp}.xlsx`;
        }

        const blob = await response.blob();
        
        const downloadUrl = window.URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        
        return { success: true, message: 'File downloaded successfully' };
    } catch (error) {
        log('Error downloading Excel file:', error);
        toast.error('Error downloading file');
        return { success: false, error: error.message };
    }
};
